import { NewslettersApi } from "@app/bf-api";
import { INewNewsletterFormValues } from "@app/core/newsletter";
import { AppThunk } from "../store";

export const subscribeToNewsletter =
  (values: INewNewsletterFormValues, recaptchaToken: string): AppThunk =>
  async (_dispatch, getState) => {
    try {
      const api = new NewslettersApi();
      const platformId = getState().settings.platformId;
      const currentPage = window.location.href;

      await api.subscribe({
        platformId,
        subscriberDTO: {
          email: values.emailAddress,
          subscribeURL: currentPage
        },
        xRecaptchaToken: recaptchaToken
      });
    } catch (error) {
      // tslint:disable-next-line: no-unused-expression no-unsafe-any
      // new FatalError(error.name, error.message, error.stack);
    }
  };

export const newsletterThunks = {
  subscribeToNewsletter
};
